var _rect, _g, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _ellipse2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 265,
    viewBox: "0 0 387 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07886,
    y: 10.6304,
    width: 219.053,
    height: 140.211,
    rx: 9,
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2020_32612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.579 59.8382C106.862 55.4601 106.364 50.9229 106.58 49.2016L101.422 45.8424L93.5528 45.2148C90.4504 47.6508 84.867 54.3409 87.3525 61.6141C90.4595 70.7055 95.6218 76.7862 100.07 76.3473C104.519 75.9084 105.909 67.1756 106.188 66.5176C106.468 65.8596 106.603 62.8091 107.539 62.4303C108.475 62.0514 110.208 61.6226 110.579 59.8382Z",
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3609 79.5714L93.4806 72.895L87.7617 67.0982L82.0807 76.2277L93.3609 79.5714Z",
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0823 54.1342C98.8273 51.6539 103.697 50.9538 106.038 50.9138L105.894 48.5213L102.193 48.1128L93.9959 47.3457L89.3735 55.4806C88.6127 57.8765 87.8052 63.9044 90.6614 68.8488C94.2316 75.0293 98.6848 77.3119 101.961 75.9858C104.582 74.925 106.902 66.1898 106.762 62.8764L97.5416 66.3362C97.3342 63.7875 97.1519 57.7789 98.0823 54.1342Z",
    fill: "#00004E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.394 119.206C112.77 95.5055 110.973 82.2093 91.9928 78.2277C84.7445 75.4475 65.4859 71.5639 61.5188 80.1873C45.56 114.878 49.7874 135.084 40.5526 150.92C33.061 163.767 -3.13796 235.765 -7.99221 252.142L75.4877 276.887C80.0808 266.497 83.9466 189.267 102.065 119.206C107.676 129.207 113.641 133.451 119.97 135.327C130.057 138.317 146.342 124.209 168.078 96.5778L160.341 90.3146C153.619 96.5643 140.079 107.048 122.394 119.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3231 103.557C96.3555 109.466 100.084 115.676 102.065 119.206M102.065 119.206C107.676 129.207 113.641 133.451 119.97 135.327C130.057 138.317 146.342 124.209 168.078 96.5778L160.341 90.3146C153.619 96.5643 140.079 107.048 122.394 119.206C112.77 95.5055 110.973 82.2093 91.9928 78.2277C84.7445 75.4475 65.4859 71.5639 61.5188 80.1873C45.56 114.878 49.7874 135.084 40.5526 150.92C33.061 163.767 -3.13796 235.765 -7.99221 252.142L75.4877 276.887C80.0808 266.497 83.9466 189.267 102.065 119.206Z",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51 49.3392L106.353 49.3898C107.192 47.4159 105.022 37.9456 97.7603 36.7996C90.499 35.6536 86.2435 39.2826 85.6838 40.5985C85.1241 41.9144 78.3593 56.9081 73.5006 63.777C68.6418 70.6459 46.9809 109.607 61.4614 115.766C77.552 121.484 88.6843 81.9023 93.3476 55.6169C93.8345 52.8725 97.75 51.2734 100.51 49.3392Z",
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.449 44.4839C99.4067 43.4309 87.0845 42.4634 84.1974 41.2354",
    stroke: "#00004E",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.919742,
    cy: 1.84165,
    rx: 0.919742,
    ry: 1.84165,
    transform: "matrix(0.986705 -0.162523 0.160078 0.987104 102.792 53.0811)",
    fill: "#00004E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.605 151.104L98.4467 134.525L94.394 151.104H112.447H131.605Z",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0782 80.7354C93.2889 96.4546 80.0259 130.104 50.5522 138.946",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3425,
    y: 121.846,
    width: 32.1311,
    height: 40.1639,
    rx: 6,
    transform: "rotate(24.9719 39.3425 121.846)",
    fill: "#00004E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9208 111.314L44.658 124.578",
    stroke: "#00004E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.882 92.1911C169.844 85.2485 172.363 72.8044 182.741 78.5686",
    stroke: "#00BF00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.98 94.1076C194.724 97.1655 191.444 97.6834 189.961 97.5602C189.856 98.0345 189.6 99.3748 189.417 100.941C194.22 101.801 198.767 99.4121 199.72 93.4962C200.673 87.5803 202.189 86.7839 204.375 85.0551C204.227 84.7134 203.889 83.763 203.714 82.6944C198.993 84.0148 197.549 90.2852 195.98 94.1076Z",
    fill: "#00BF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84 76.8919L168.882 92.7775L188.965 103.209L192.771 81.1919L183.84 76.8919Z",
    fill: "#00BF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.712 89.9591L174.749 86.7198L190.48 94.0227L189.62 98.8263L171.712 89.9591Z",
    fill: "#81E791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.863 79.9037L182.441 78.4471L192.708 82.8282L192.08 84.7282L180.863 79.9037Z",
    fill: "#81E791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.293 82.5733L161.512 90.809L164.763 93.63C165.717 92.6532 167.349 91.2334 169.331 90.7452C171.809 90.135 171.478 88.0366 171.864 85.7165C172.249 83.3964 175.333 83.2274 178.031 81.2914C176.929 79.7461 170.413 81.5022 167.293 82.5733Z",
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.868,
    y: 115.999,
    width: 219.053,
    height: 140.211,
    rx: 9,
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0788574,
    y: 22.8936,
    width: 221.053,
    height: 1.47368,
    fill: "#00004E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 165.868,
    y: 128.999,
    width: 221.053,
    height: 1.47368,
    fill: "#00004E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.55261,
    cy: 17.3671,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.079,
    cy: 122.735,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1315,
    cy: 17.3671,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.658,
    cy: 122.735,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7103,
    cy: 17.3671,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.237,
    cy: 122.735,
    r: 2.31579,
    stroke: "#00004E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.868 124.239C244.097 123.578 243.942 122.912 243.637 122.325L242.776 120.671C239.416 122.419 238.312 127.402 238.335 131.12C235.303 128.967 230.59 127.012 227.229 128.76L228.09 130.415C228.423 131.055 228.952 131.458 229.625 131.65L240.662 135.469L243.868 124.239Z",
    fill: "#00BF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.484 122.823C236.56 122.606 236.509 122.387 236.408 122.194L236.125 121.65C235.02 122.225 234.657 123.863 234.664 125.086C233.667 124.378 232.117 123.735 231.012 124.31L231.295 124.854C231.405 125.065 231.579 125.197 231.8 125.26L235.43 126.517L236.484 122.823Z",
    fill: "#00BF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.611 134.535C245.807 134.148 245.768 133.726 245.629 133.34L245.24 132.253C243.031 133.044 241.935 136.009 241.637 138.293C239.957 136.718 237.227 135.122 235.018 135.914L235.408 137.001C235.559 137.422 235.849 137.714 236.247 137.889L242.701 141.159L245.611 134.535Z",
    fill: "#00BF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.117 143.617C243.015 140.964 241.04 133.383 233.949 124.281",
    stroke: "#007300",
    strokeWidth: 1.85049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.296 120.776C230.486 122.599 233.413 124.543 234.727 125.286C234.987 123.863 235.264 120.463 234.295 118.249C233.084 115.481 229.808 114.173 228.849 115.168C227.889 116.162 227.808 118.496 229.296 120.776Z",
    fill: "#00BF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.519 156.194C251.484 199.117 285.737 205.549 302.611 202.105L306.278 181.63C254.111 186.002 252.179 160.964 249.474 155.797C247.928 155.797 244.837 156.194 242.519 156.194Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.276 151.464C236.889 150.336 236.316 147.82 237.119 146.779C237.703 145.883 238.731 146.225 238.405 147.206C238.079 148.188 238.023 150.077 238.455 150.493C238.802 150.826 239.185 151.735 239.334 152.148",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 155.797L242.365 154.758C240.488 155.035 238.715 155.104 238.063 155.104C237.281 154.758 235.326 153.718 234.935 151.986C234.622 151.155 234.544 150.601 234.544 150.254C234.153 149.215 235.593 148.448 235.717 149.215C236.108 151.64 236.89 152.333 238.063 152.333C239.169 152.333 239.627 151.64 241.974 151.293C244.32 150.947 246.666 150.601 248.231 151.293C249.795 151.986 247.84 153.718 247.84 155.45",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.611 202.125C292.841 204.108 278.83 202.221 264.221 194.994C263.499 194.637 262.849 194.149 262.306 193.553C254.982 185.528 246.482 173.299 242.519 156.192C244.837 156.192 247.928 155.797 249.474 155.797C251.355 159.368 258.632 175.446 273.132 183.446C282.632 184.91 290.73 184.771 306.632 183.446",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.438 151.202L236.774 142.585H248.837L247.173 151.202H238.438Z",
    fill: "#00BF00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M296.698 189.42C297.437 184.633 299.432 183.578 299.735 184.042H326.633C350.219 194.636 360.803 224.075 362.919 233.417C363.524 235.426 365.097 240.589 366.548 245.169C367.153 250.593 361.407 256.319 356.872 256.319H290.044C290.952 250.292 288.835 248.183 287.323 246.073C291.556 244.667 300.628 241.674 303.047 240.95C301.112 236.611 300.683 230.705 300.711 228.294C293.519 216.841 293.518 213.036 295.186 204.488C296.127 199.666 296.093 193.338 296.698 189.42Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M322.645 182.65C329.303 182.044 365.245 214.145 365.245 256.514L346.784 256.514",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.625 184.043C299.324 183.577 297.347 184.636 296.614 189.442C296.015 193.375 296.049 199.728 295.116 204.568C293.017 215.459 293.584 218.681 308.002 239.661",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.905 184.05C301.294 182.643 300.612 185.37 299.589 191.506C299.21 193.778 299.248 196.96 298.226 203.437C296.327 215.466 296.41 218.187 311.179 239.229",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.309 159.243C310.246 160.303 310.462 162.619 311.837 163.402C313.212 164.185 313.682 168.608 313.746 170.157",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.088 172.352C297.555 180.914 305.066 181.073 308.764 180.082C310.223 179.79 314.893 175.325 317.812 169.082C320.439 162.541 312.558 158.676 310.223 158.676C302.342 158.379 297.088 167.298 297.088 172.352Z",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M296.862 169.822C297.401 179.717 306.075 179.9 310.345 178.755C312.03 178.418 317.423 173.258 320.794 166.043C323.828 158.484 314.727 154.018 312.03 154.018C302.929 153.674 296.862 163.981 296.862 169.822Z",
    fill: "white",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.991969,
    cy: 1.55289,
    rx: 0.991969,
    ry: 1.55289,
    transform: "matrix(0.675579 0.737288 -0.738959 0.67375 310.374 159.946)",
    fill: "#00004E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.827588,
    cy: 1.29556,
    rx: 0.827588,
    ry: 1.29556,
    transform: "matrix(0.675579 0.737288 -0.738959 0.67375 304.099 156.608)",
    fill: "#00004E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M277.091 252.183L289.022 249.456C291.203 249.729 290.613 254.115 290.044 256.274C287.431 256.274 281.659 256.342 279.477 256.615C278.114 257.637 274.023 257.978 272.66 257.296C272.205 257.524 271.228 258.183 270.955 259.001C270.614 259.682 269.864 261.455 269.592 263.091C267.683 262.819 268.114 259.114 268.569 257.296C268.114 258.546 266.933 261.387 265.842 262.75C264.478 264.455 265.16 258.66 265.16 257.296C266.251 250.206 273.569 250.933 277.091 252.183Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.351 193.708C335.356 196.47 341.548 203.641 349.648 215.08C360.733 230.733 360.271 243.429 360.271 246.191C360.271 248.953 357.5 256.319 349.648 256.319C335.238 256.319 305.643 256.319 290.094 256.319C290.556 254.324 290.648 249.506 287.323 246.191C298.407 242.14 322.116 235.295 332.584 232.38C331.045 223.939 326.396 205.954 320.114 201.534",
    stroke: "#00004E",
    strokeWidth: 1.85049,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.152 187.964C311.428 188.273 308.148 188.724 306.323 198.177C303.694 211.802 312.066 222.781 313.98 224.638C315.894 226.495 321.664 230.998 321.185 235.64",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.365 188.097C309.623 193.599 304.946 207.976 316.171 221.462C320.38 226.73 324.133 229.344 324.473 234.457",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M289.046 249.426L277.152 252.133C269.625 249.877 265.391 253.486 264.921 257.095C264.921 258.899 265.053 258.289 265.524 259.191",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M268.103 254.596C267.441 255.389 265.918 255.738 265.124 260.306C264.131 266.015 266.644 261.776 267.11 260.387C268.516 256.19 269.594 256.975 270.091 256.499",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.793 258.826C267.793 259.527 268.072 263.212 269.186 263.212C269.651 263.212 270.115 263.212 270.115 261.108C270.115 259.003 272.437 256.899 272.902 257.425C273.366 257.951 277.546 257.951 278.939 256.899C280.797 256.478 285.751 256.197 289.621 256.372",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M299.737 179.558C296.053 176.385 296.77 174.641 297.282 172.2C300.658 184.097 310.706 175.791 312.634 173.457C322.459 161.56 314.783 156.069 312.634 154.848C311.568 154.243 308.361 153.628 305.904 154.848C312.634 148.186 322.308 154.848 323.746 157.08C324.786 158.693 325.845 160.371 326.45 162.78C327.775 168.05 325.512 169.811 324.897 170.421C324.283 171.032 323.746 177.24 325.222 181.388C327.79 188.604 318.467 189.015 316.625 188.71C314.784 188.404 314.169 187.184 308.335 188.404C302.501 189.625 299.737 185.659 297.282 182.303C297.384 181.592 298.018 180.046 299.737 179.558Z",
    fill: "#00004E",
    stroke: "#00004E",
    strokeWidth: 1.85049
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M300.557 168.658C300.148 167.227 303.73 164.287 305.024 163.4L302.806 169.563C302.125 169.758 300.529 169.33 300.557 168.658Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M306.369 159.946C304.897 160.953 301.099 162.834 301.564 164.461C301.532 165.225 303.346 165.712 304.121 165.49",
    stroke: "#00004E",
    strokeWidth: 1.85049,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2020_32612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.368,
    height: 149.579,
    fill: "white",
    transform: "translate(1.55249 0.788086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeImg);
export default __webpack_public_path__ + "static/media/welcomeImg.07c34ac0.svg";
export { ForwardRef as ReactComponent };